import { Directive, HostListener } from '@angular/core';
import { NaScreenfullService } from './na-screenfull.service';

/**
 * Binds a host elementÂ´s click to the {@see NaScreenfullService} toggle method
 */
@Directive({
  selector: '[naToggleFullscreen]'
})
export class NaToggleFullscreenDirective {

  /**
   * Creates a new instance
   * @param screenfullService the screen service singletone instance
   */
  constructor(private readonly screenfullService: NaScreenfullService) { }

  /**
   * Toggles the fullscreen mode
   */
  @HostListener('click')
  toggle() {
    this.screenfullService.toggle();
  }
}
